import downloadData from '../../../utilities/downloadData';

export const defaultOptions = {
  exporting: {
    enabled: true,
    buttons: {
      contextButton: {
        menuItems: [
          'viewFullscreen',
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
          'separator',
          'downloadData',
        ],
      },
    },
    menuItemDefinitions: {
      downloadData: {
        onclick: downloadData,
        text: 'Download Chart Data',
      },
    },
  },
  credits: { enabled: false },
  chart: {
    type: 'line',
    zoomType: 'x',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    spacingTop: 50,
  },
  legend: {
    floating: true,
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'top',
    x: 50,
    y: 50,
    backgroundColor: 'white',
    borderRadius: 5,
    height: 60,
    shadow: true,
    itemWidth: 180,
    itemStyle: {
      textOverflow: 'wrap',
      fontSize: 12,
    },
  },
  xAxis: {
    title: {
      text: 'Year',
    },
  },
  navigation: {
    buttonOptions: {
      y: -45,
      x: -18,
    },
  },
  title: {
    widthAdjust: -100,
  },
};
